// @ts-check

import React, { createContext, useContext, useEffect, useMemo, useState } from "react";

import { generateUtmLink } from "utils/index.js";

const UtmLinksContext = createContext({});

export const TABS = [
  { id: "custom", content: "Custom" },
  { id: "facebook", content: "Facebook" },
];

export const UtmLinksProvider = ({ children }) => {
  const [tabIndex, setTabIndex] = useState(0);
  const [error, setError] = useState(null);

  const selectedTab = TABS[tabIndex];

  const [baseUrl, setBaseUrl] = useState("");
  const [utmSource, setUtmSource] = useState("");
  const [utmMedium, setUtmMedium] = useState("");
  const [utmCampaign, setUtmCampaign] = useState("");
  const [utmContent, setUtmContent] = useState("");
  const [utmTerm, setUtmTerm] = useState("");

  useEffect(() => {
    setUtmSource(() => (selectedTab.id === "facebook" ? "{{site_source_name}}" : ""));
    setUtmMedium(() => (selectedTab.id === "facebook" ? "{{adset.name}}" : ""));
    setUtmCampaign(() => (selectedTab.id === "facebook" ? "{{campaign.name}}" : ""));
    setUtmContent(() => (selectedTab.id === "facebook" ? "{{ad.name}}" : ""));
    setUtmTerm(() => (selectedTab.id === "facebook" ? "{{placement}}" : ""));
  }, [selectedTab]);

  const generatedLink = useMemo(() => {
    return generateUtmLink({
      baseUrl,
      utmSource,
      utmMedium,
      utmCampaign,
      utmContent,
      utmTerm,
      type: selectedTab.id,
    });
  }, [baseUrl, utmSource, utmMedium, utmCampaign, utmContent, utmTerm, selectedTab]);

  return (
    <UtmLinksContext.Provider
      value={{
        tabIndex,
        setTabIndex,
        error,
        setError,
        selectedTab,
        baseUrl,
        setBaseUrl,
        utmSource,
        setUtmSource,
        utmCampaign,
        setUtmCampaign,
        utmMedium,
        setUtmMedium,
        utmContent,
        setUtmContent,
        utmTerm,
        setUtmTerm,
        generatedLink,
      }}
    >
      {children}
    </UtmLinksContext.Provider>
  );
};

export const useUtmLinks = () => {
  const context = useContext(UtmLinksContext);

  return context;
};
